import { STATUSES, StatusId } from "~/common/constants";
import { buildStatusFilter } from "~/components/patient/patients-status-filter";

export const TABS = [
  { key: "all", labelId: "redesign.patients.tab.all", defaultMessage: "All patients", statuses: [] as StatusId[] },
  {
    key: "waiting",
    labelId: "redesign.patients.tab.waiting",
    defaultMessage: "Awaiting action",
    statuses: [
      StatusId.RETAKE_IMPRESSIONS,
      StatusId.WAITING_FOR_PAYMENT,
      StatusId.PLAN_APPROVAL,
      StatusId.RETAINERS_RETAKE_IMPRESSIONS,
      StatusId.RETAINERS_WAITING_FOR_PAYMENT,
      StatusId.POWER_CAP_RETAKE_IMPRESSIONS,
      StatusId.POWER_CAP_WAITING_FOR_PAYMENT,
      StatusId.POWER_CAP_PLAN_APPROVAL,
    ],
  },
  {
    key: "working",
    labelId: "redesign.patients.tab.working",
    defaultMessage: "In progress",
    statuses: [
      StatusId.INSTRUCTIONS_PROCESSING,
      StatusId.SCANNING_3D,
      StatusId.MODELING_3D,
      StatusId.PRODUCTION_PRINTING,
      StatusId.PRODUCTION_MOLDING,
      StatusId.PRODUCTION_MARKING,
      StatusId.PRODUCTION_FABRICATING,
      StatusId.PRODUCTION_QUALITY_CONTROL,
      StatusId.FINAL_STAGE_READY,
      StatusId.RETAINERS_ORDERED,
      StatusId.RETAINERS_SCANNING,
      StatusId.RETAINERS_PRINTING,
      StatusId.RETAINERS_FABRICATING,
      StatusId.RETAINERS_READY,
      StatusId.POWER_CAP_ORDERED,
      StatusId.POWER_CAP_SCANNING_3D,
      StatusId.POWER_CAP_MODELING_3D,
      StatusId.POWER_CAP_PRODUCTION_PRINTING,
      StatusId.POWER_CAP_PRODUCTION_MOLDING,
      StatusId.POWER_CAP_PRODUCTION_MARKING,
      StatusId.POWER_CAP_PRODUCTION_FABRICATING,
      StatusId.POWER_CAP_PRODUCTION_QUALITY_CONTROL,
      StatusId.POWER_CAP_READY,
    ],
  },
  { key: "drafts", labelId: "redesign.patients.tab.drafts", defaultMessage: "Drafts", statuses: [StatusId.UNFILLED_CASE] },
  { key: "done", labelId: "redesign.patients.tab.done", defaultMessage: "Completed", statuses: [StatusId.TREATMENT_FINISHED] },
  { key: "canceled", labelId: "redesign.patients.tab.canceled", defaultMessage: "Not started", statuses: [StatusId.TREATMENT_CANCELED] },
] as const;

export type TabKey = (typeof TABS)[number]["key"];

export function statusParamFor(tabKey: TabKey): string | false {
  const tab = TABS.find((t) => t.key === tabKey);
  if (!tab || tab.statuses.length === 0) return false;
  const ids = new Set<StatusId>(tab.statuses);
  return buildStatusFilter(STATUSES.filter((s) => ids.has(s.value)));
}
export const AWAITING_ACTION_TAB: TabKey = "waiting";
